const dayNames = [
    'SUNDAY',
    'MONDAY',
    'TUESDAY',
    'WEDNESDAY',
    'THURSDAY',
    'FRIDAY',
    'SATURDAY',
];

export function formatNumber(value: number, digitCount = 2): string {
    const output = value.toString();
    if (output.length < digitCount) {
        return Array(digitCount - output.length).fill(0).join('') + output;

    }
    return output;

}

export function getFormattedDayName(date: Date) {
    return dayNames[date.getDay()];
}

export function getFormattedDate(date: Date) {
    return `${formatNumber(date.getDate())}.${formatNumber(date.getMonth() + 1)}.${formatNumber(date.getFullYear())}`;
}

export function getFormattedTime(date: Date) {
    return `${formatNumber(date.getHours())}:${formatNumber(date.getMinutes())}`;
}
